import React from "react";
import { Box } from "@mui/material";

const Cards6A = () => {
  const layout = [
    { num: 1, col: 3, row: 4 },
    { num: 2, col: 1, row: 3 },
    { num: 3, col: 5, row: 3 },
    { num: 4, col: 1, row: 2 },
    { num: 5, col: 3, row: 1 },
    { num: 6, col: 5, row: 2 },
  ];

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "repeat(4, 30px)",
        gridTemplateRows: "repeat(4, 53px)",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {layout.map(({ num, col, row }) => (
        <Box
          key={num}
          sx={{
            gridColumn: col,
            gridRow: row,
            width: 43,
            height: 48,
            backgroundColor: "#1976d2",
            borderRadius: "10px",
            color: "white",
            fontWeight: "bold",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            userSelect: "none",
          }}
        >
          {num}
        </Box>
      ))}
    </Box>
  );
};

export default Cards6A; // Corrected export name to match the file name
